<template>
  <div class="special-offer-wrapper" v-if="list && list.length">
    <router-link class="timer-counter" to="/recommend-goods?type=13">
      <img :src="img" alt="限时特价">
      <div class="counter">
        <time-counter :h="exp.h" :m="exp.m" :s="exp.s"></time-counter>
      </div>
    </router-link>
    <swiper :options="swiperOption" ref="mySwiper">
      <!-- slides -->
      <swiper-slide v-if="item.isToday" v-for="(item, index) in list" :key="index">
        <!-- <div class="goods-item">
          <router-link :to="'/goods?goods_id=' + item.goodsId" target="_blank">
            <img :src="item.imgUrl" alt="goods">
          </router-link>
        </div> -->

        <div class="goods-item">
          <router-link :to="'/goods?goods_id=' + item.goodsId" target="_blank">
            <!-- <img :src="item.imgUrl" alt="goods"> -->
            <div class="img">
              <img :src="item.imgUrl" :atl="item.title" />
            </div>
            <div class="tit">{{item.title}}</div>
            <div class="pri">&yen;&nbsp;{{item.price}}</div>
          </router-link>
        </div>
      </swiper-slide>
      <!-- Optional controls -->
      <!--<div class="swiper-pagination"  slot="pagination"></div>-->
      <!--<div class="swiper-button-prev" slot="button-prev"></div>-->
      <!--<div class="swiper-button-next" slot="button-next"></div>-->
      <!--<div class="swiper-scrollbar"   slot="scrollbar"></div>-->
    </swiper>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import moment from 'moment'
import img from 'assets/images/index-ads/special-offer.png'
import timeCounter from './counter'

export default {
  props: [
    'list',
  ],
  components: {
    swiper,
    swiperSlide,
    timeCounter,
  },
  data() {
    // let num = this.list.length;
    // if (num >= 5) num = 5;

    return {
      timer: null,
      et: 0,
      exp: {},
      img: img,
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 10,
        // navigation: {
        //   nextEl: 'swiper-button-next',
        //   prevEl: 'swiper-button-prev',
        // }
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  mounted() {
    if (this.list.length) {
      this.swiper.slideTo(3, 1000, false)
    }
  },
  created() {
    // let endTime = this.et;
    let endTime = moment().endOf('day').valueOf();
    let exp = {};
    let totalSeconds = parseInt((new Date(endTime) * 1 - Date.now()) / 1000);
    let _h = parseInt((totalSeconds % (24 * 3600)) / 3600);
    let _m = parseInt((totalSeconds % 3600) / 60);
    let _s = parseInt(totalSeconds % 3600 % 60);
    let s, m, h;
    this.timer = setInterval(() => {
      if (--_s < 0 && _m >= 0) {
        _s = 59;
        if (--_m < 0 && _h > 0) {
          _m = 59;
          --_h;
        }
      }
      s = Math.max(_s, 0);
      m = Math.max(_m, 0);
      h = Math.max(_h, 0);
      this.exp = {
        h, m, s
      };
      if (s == 0 && m == 0 && h == 0) {
        clearInterval(this.timer)
      }
    }, 1000);
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    getDuration(d) {
      let ss = d;
      let h = (ss / 60 / 60).toFixed() * 1;
      ss = ss % (60 * 60);
      let m = (ss / 60).toFixed() * 1;
      let s = ss % 60;
      return {
        h, m, s
      }
    }
  }
}
</script>

<style scoped lang="less">
.swiper-slide {
  width: 220px !important;
}
.special-offer-wrapper {
  display: flex;
  flex-direction: row;
  margin-top: 20px;
  padding: 10px 20px 10px 12px;
}

.timer-counter {
  position: relative;
  margin-right: 10px;

  .counter {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
  }
  img {
    height: 300px;
    width: 230px;
    border-radius: 10px;
  }
}

.goods-item {
  height: 300px;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  padding: 5px;
  a {
    display: block;
    height: inherit;
  }
  .img {
    display: table-cell;
    text-align: center;
    vertical-align: middle;
    width: 220px;
    height: 220px;
    img {
      width: 210px;
      height: 210px;
    }
  }
  .tit {
    width: 210px;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .pri {
    color: #f20015;
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?6928f848